module.exports = __webpack_public_path__ + "Roboto-Regular.947d4eb3b5e0a4ca56cf.eot";


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/OESS_LFB_V2demo/src/assets/fonts/Roboto-Regular.eot
// module id = ../../../../../src/assets/fonts/Roboto-Regular.eot
// module chunks = main